import { render, staticRenderFns } from "./JoinTeamView.vue?vue&type=template&id=08016933"
import script from "./JoinTeamView.vue?vue&type=script&lang=js"
export * from "./JoinTeamView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports